import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { Dialog } from '../../base';
import { TreeList } from '../../lists';
const TreeListDialogFC = ({ trees, title, isPending, activeItems, isClickOnActiveDisabled, onClickTreeItem, onClose }) => {
    return (_jsx(Dialog, { noOverflow: true, onlyTitlePadding: true, title: title, onClose: onClose, children: _jsx(Box, { w: '440px', borderTop: '1px solid', borderColor: 'border', children: _jsx(TreeList, { trees: trees, height: '75dvh', maxHeight: '75dvh', isPending: isPending, activeItems: activeItems, isClickOnActiveDisabled: isClickOnActiveDisabled, onClickTreeItem: onClickTreeItem }) }) }));
};
export const TreeListDialog = TreeListDialogFC;
//# sourceMappingURL=TreeListDialog.js.map